import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

const getProducts = (state: BP42InitialState): EProductsId[] => state.selectedProducts;

export default getProducts;
